import { bootBlock, claim } from '../../src/js/blockRuntime';

const blogPostsPagination = {
    init: function(root) {
        this.hideArrowMobile(root);
    },
    hideArrowMobile: (root) => {
        const categories = root.querySelector('.blog-posts-pagination__categories');

        if (!claim(categories, 'juniperArrow')) return;

        function hideArrow() {
            categories.classList.add('var_hide_arrow');
            categories.removeEventListener('scroll', hideArrow);
        }

        categories.addEventListener('scroll', hideArrow)
    }
};

bootBlock('blog-posts-pagination', (root) => blogPostsPagination.init(root));
